function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import ReactDOM from 'react-dom';
import { PanelToolStyles } from './PanelToolStyles';
import { ThemeProvider } from 'oskari-ui/util';
/**
 * @class Oskari.mapframework.bundle.publisher.view.PanelToolLayout
 *
 * Represents a tool layout panel (lefthanded / righthanded / custom) for the publisher as an Oskari.userinterface.component.AccordionPanel.
 * Allows the user to change the positioning of the tools on the map.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.publisher2.view.PanelLayout',
/**
 * @method create called automatically on construction
 * @static
 * @param {Object} sandbox
 * @param {Object} mapmodule
 * @param {Object} localization
 *       publisher localization data
 * @param {Oskari.mapframework.bundle.publisher2.instance} instance the instance
 */
function (sandbox, mapmodule, localization, instance) {
  var me = this;
  me.loc = localization;
  me.instance = instance;
  me.sandbox = sandbox;
  me.mapModule = mapmodule;
  me._originalToolStyle = null;
  me.fonts = [{
    name: 'Arial (sans-serif)',
    val: 'arial'
  }, {
    name: 'Georgia (serif)',
    val: 'georgia'
  }, {
    name: 'Fantasy (sans-serif)',
    val: 'fantasy'
  }, {
    name: 'Verdana (sans-serif)',
    val: 'verdana'
  }];
  // The values to be sent to plugins to actually change the style.
}, {
  /**
   * @method getName
   * @return {String} the name of the component
   */
  getName: function getName() {
    return 'Oskari.mapframework.bundle.publisher2.view.PanelLayout';
  },
  /**
   * Creates the DOM elements for layout change components and
   * prepopulates the fields if pData parameter is given.
   *
   * @method init
   * @param {Object} pData initial data (optional)
   */
  init: function init(pData) {
    var _this$data;
    var me = this;
    me.data = pData || null;
    for (var p in me.eventHandlers) {
      if (me.eventHandlers.hasOwnProperty(p)) {
        me.sandbox.registerForEventByName(me, p);
      }
    }

    // Set the initial values
    var theme = (_this$data = this.data) === null || _this$data === void 0 || (_this$data = _this$data.metadata) === null || _this$data === void 0 ? void 0 : _this$data.theme;
    me.values = {
      metadata: {
        theme: theme
      }
    };

    // for restoring after exit
    this._originalTheme = Oskari.app.getTheming().getTheme();
    if (theme) {
      this.updateTheme(theme.map);
    }
    if (!me.panel) {
      me.panel = me._populateLayoutPanel();
    }
  },
  /**
   * Returns the UI panel and populates it with the data that we want to show the user.
   *
   * @method getPanel
   * @return {Oskari.userinterface.component.AccordionPanel}
   */
  getPanel: function getPanel() {
    if (!this.panel) {
      this.panel = this._populateLayoutPanel();
    }
    return this.panel;
  },
  /**
   * Returns the selections the user has done with the form inputs.
   * {
   *     metadata : {
   *          theme: { ... theme for embedded map ... }
   *     }
   * }
   *
   * @method getValues
   * @return {Object}
   */
  getValues: function getValues() {
    var me = this;

    // metadata currently saved to two places. The publisher uses the values from metadata to restore a published map's state whereas a published map itself uses
    // the values stored under mapfull's conf.
    me.values = {
      metadata: {
        theme: Oskari.app.getTheming().getTheme()
      }
    };
    return me.values;
  },
  _populateLayoutPanel: function _populateLayoutPanel() {
    var _this = this;
    var panel = Oskari.clazz.create('Oskari.userinterface.component.AccordionPanel');
    var contentPanel = panel.getContainer();
    panel.setTitle(this.loc.layout.label);
    var styleEditor = jQuery('<div />');
    contentPanel.append(styleEditor);
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(PanelToolStyles, {
      mapTheme: this.mapModule.getMapTheme(),
      changeTheme: function changeTheme(theme) {
        return _this.updateTheme(theme);
      },
      fonts: this.fonts
    })), styleEditor[0]);
    return panel;
  },
  updateTheme: function updateTheme(mapTheme) {
    Oskari.app.getTheming().setTheme(_objectSpread(_objectSpread({}, this._originalTheme), {}, {
      map: mapTheme
    }));
  },
  /**
  * Stop panel.
  * @method stop
  * @public
  **/
  stop: function stop() {
    // change the mapmodule theme back to normal
    Oskari.app.getTheming().setTheme(this._originalTheme);
  }
});